import React, { Component } from "react";
import _ from "lodash";
import { Form, Row, Col, Modal, Button } from "react-bootstrap";
import "./create-pdf.css";
import { Image, PriceImg, logo_image } from "../../../assets/images";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { message } from "antd";
import axios from "../../../axios/axios";
// import Link from "react-dom";
import LoadingOverlay from "react-loading-overlay";
import { adminConfig } from "../../../utils/adminConfig";

export default class CreatePdf extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,

      inputData: {
        banner: "",
        pricetag: "",
        qr_code: "https://redeem.tripvalet.com/",
        certificate_description: "",
        referral_code: "",
        certificate_code: "",
      },

      all_certificates: [],

      show: false,
      certificate_id: "",
    };
  }

  componentDidMount = () => {
    this.getAllTravelCertificate();
  };

  handleImages = (e) => {
    let { inputData } = this.state;

    let file = e.target.files[0];
    let validExtension = ["png", "jpg", "jpeg"];
    if (file !== undefined) {
      let extension = this.getFileExtension(file);
      if (
        extension !== undefined &&
        _.findIndex(validExtension, (exe) => {
          return exe === extension;
        }) !== -1
      ) {
        inputData[e.target.name] = file;
      } else {
        message.error("The file format is not supported");
      }
    }
    this.setState({ inputData });
  };

  getFileExtension = (file) => {
    let regex = new RegExp("[^.]+$");
    return file.name.match(regex)[0].toLowerCase();
  };

  handleOnChange = (e) => {
    let { name, value } = e.target;

    let { inputData } = this.state;

    inputData[name] = value;

    this.setState(inputData);
  };

  addNewCertificate = (e) => {
    e.preventDefault();

    let { inputData } = this.state;

    if (!inputData.certificate_description) {
      message.error("Please add certificate content");
      return;
    }

    let formData = new FormData();

    formData.append("banner", inputData.banner);
    formData.append("pricetag", inputData.pricetag);
    formData.append("qr_code", inputData.qr_code);
    formData.append("referral_code", inputData.referral_code);
    formData.append("certificate_code", inputData.certificate_code);
    formData.append(
      "certificate_description",
      inputData.certificate_description
    );

    this.setState({ isLoading: true });

    axios
      .post("/add-travel-certificate", formData, adminConfig())
      .then((res) => {
        this.setState({ isLoading: false });

        if (res.data.status) {
          message.success(res.data.message);
          this.setState({
            inputData: {
              banner: "",
              pricetag: "",
              qr_code: "https://redeem.tripvalet.com/",
              certificate_description: "",
              referral_code: "",
              certificate_code: "",
            },
          });
          this.getAllTravelCertificate();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ isLoading: false });

        message.error("Something went wrong");
      });
  };

  getAllTravelCertificate = () => {
    this.setState({ isLoading: true });

    axios
      .get("/get-all-travel-certificate", adminConfig())
      .then((res) => {
        this.setState({ isLoading: false });

        if (res.data.status) {
          this.setState({ all_certificates: res.data.all_travel_certificate });
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ isLoading: false });
        message.error("Something went wrong");
      });
  };

  deleteTravelCertificate = () => {
    this.setState({ isLoading: true });

    axios
      .delete("/travel-certificate/" + this.state.certificate_id, adminConfig())
      .then((res) => {
        //this.setState({ isLoading: false });

        if (res.data.status) {
          this.setState({ show: false, certificate_id: "" });
          message.success("Deleted successfully");
          this.getAllTravelCertificate();
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ isLoading: false });
        message.error("Something went wrong");
      });
  };

  handleModalOpen = (certificate_id) => {
    this.setState({ show: true, certificate_id: certificate_id });
  };

  handleClose = () => {
    this.setState({ show: false, certificate_id: "" });
  };

  render() {
    let { inputData, all_certificates } = this.state;
    return (
      <LoadingOverlay spinner active={this.state.isLoading} text="Loading...">
        <div className="right_cont">
          <div className="right_banner_banner_cnt">
            <div className="travel_deals_admin">
              <h2>Hello, Admin!</h2>

              <Modal show={this.state.show}>
                <Modal.Header>
                  <Modal.Title>
                    Are You Sure Delete This Certificate?
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="d-flex button_group justify-content-center align-items-center">
                    <Button
                      className="no"
                      variant="primary"
                      onClick={this.handleClose}
                    >
                      No
                    </Button>
                    <Button
                      className="yes"
                      variant="secondary"
                      onClick={() => {
                        this.deleteTravelCertificate();
                      }}
                    >
                      Yes
                    </Button>
                  </div>
                </Modal.Body>
              </Modal>

              <div className="pdf_inner_partts">
                <Form onSubmit={this.addNewCertificate}>
                  <div className="upload_banner_image">
                    <h2>Upload Banner Image</h2>
                    <div className="upload-btn-wrapper121">
                      <img
                        src={
                          inputData.banner
                            ? URL.createObjectURL(inputData.banner)
                            : Image
                        }
                        alt="banner"
                      />
                      <button className="btn">Upload Banner Image</button>
                      <input
                        type="file"
                        name="banner"
                        accept="image/png, image/jpg, image/jpeg"
                        onChange={this.handleImages}
                        required
                      />
                    </div>
                  </div>
                  <div className="price_field">
                    <Form.Group>
                      <Form.Label>Upload Price:</Form.Label>
                      <div className="upload-btn-wrapper121">
                        <img
                          src={
                            inputData.pricetag
                              ? URL.createObjectURL(inputData.pricetag)
                              : PriceImg
                          }
                          alt="price tag"
                        />
                        <button className="btn">Upload Price Image</button>
                        <input
                          type="file"
                          name="pricetag"
                          accept="image/png, image/jpg, image/jpeg"
                          onChange={this.handleImages}
                          required
                        />
                      </div>
                    </Form.Group>
                  </div>

                  <div className="upload_banner_image up_qr_code">
                    <h2>Enter QR Code Url</h2>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        placeholder="Enter QR Code Url"
                        className="text_link"
                        name="qr_code"
                        value={inputData.qr_code}
                        onChange={this.handleOnChange}
                        required
                        readOnly
                      />
                    </Form.Group>
                  </div>

                  {/* <div className="upload_banner_image up_qr_code">
                    <h2>Enter Referral Code</h2>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        placeholder="Enter Referral Code"
                        className="text_link"
                        name="referral_code"
                        value={inputData.referral_code}
                        onChange={this.handleOnChange}
                        required
                      />
                    </Form.Group>
                  </div> */}

                  <div className="upload_banner_image up_qr_code">
                    <h2>Enter Certificate Code</h2>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        placeholder="Enter Certificate Code"
                        className="text_link"
                        name="certificate_code"
                        value={inputData.certificate_code}
                        onChange={this.handleOnChange}
                        required
                      />
                    </Form.Group>
                  </div>

                  <div className="some_content">
                    <h2>Certificate Content</h2>

                    <div className="ck_editor_inner_parttts">
                      <CKEditor
                        editor={ClassicEditor}
                        data={inputData.certificate_description}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          inputData.certificate_description = data;
                          this.setState(inputData);
                        }}
                      />
                    </div>
                  </div>
                  <div className="submit_button sub_but mt-5">
                    <button type="submit" className="add_but submit_buttt">
                      Submit
                    </button>
                  </div>
                </Form>

                <div className="pdf_box">
                  <div className="pdf_innner_box">
                    {all_certificates.map((certificate, key) => {
                      return (
                        <div className="pdf_inner_inner_box" key={key}>
                          <div className="pdf_boxi">
                            <a
                              href={`/travel-certificate-details/${certificate._id}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <div className="create_pdfff">
                                <div className="pdf_banner">
                                  <img
                                    src={certificate.banner}
                                    alt="Travel Certificate"
                                  />
                                </div>
                                <div className="pdf_content">
                                  <Row>
                                    <Col lg="3" md="4" sm="12">
                                      <div className="pdf_price_img">
                                        <img
                                          src={certificate.pricetag}
                                          className="img-fluid"
                                          alt="tag"
                                        />
                                      </div>
                                      <div className="scan_code">
                                        <img
                                          src={`https://chart.googleapis.com/chart?cht=qr&chl=${certificate.qr_code}%2F&chs=180x180&choe=UTF-8&chld=L%7C2`}
                                          className="img-fluid"
                                          alt="qr"
                                        />
                                      </div>
                                      <div className="pdf_logo_img">
                                        <img
                                          src={logo_image}
                                          className="img-fluid"
                                          alt="img"
                                        />
                                      </div>
                                    </Col>
                                    <Col lg="9" md="8" sm="12">
                                      <div className="certificate_terms">
                                        <h2>Terms of the Certificate</h2>
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              certificate.certificate_description,
                                          }}
                                        />

                                        <h3>GET YOUR CERTIFICATE TODAY!</h3>
                                        <div className="go_online">
                                          <p>
                                            Go Online:
                                            http://redeem.tripvalet.com
                                          </p>
                                          <p>
                                            Enter Referral Code: (Member
                                            Username)
                                          </p>
                                          <p>Certificate Code: 40A</p>
                                        </div>
                                        <div className="foot_cont">
                                          <p>
                                            If you have general questions about
                                            your certificate please email
                                            support@tripvalet.com Monday to
                                            Friday from 9am to 5pm Central Time.
                                          </p>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </a>
                            <div className="cross_button">
                              <a
                                href="javascript:void(0)"
                                onClick={() => {
                                  this.handleModalOpen(certificate._id);
                                }}
                              >
                                X
                              </a>
                            </div>
                          </div>
                          {/* <div
                            onClick={() => {
                              this.setState({
                                show: true,
                                certificate_id: certificate._id,
                              });
                            }}
                            className="cross"
                          >
                            X
                          </div> */}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    );
  }
}
